import useSWRV from 'swrv';
import { computed } from 'vue';

import { api } from '@/services/api-service';
import { getEndOfToday } from '@/utils/dates';

export const useReminders = () => useSWRV('reminders', api.getReminders);

export const useTodaysReminders = () => {
	const { data: reminders, ...rest } = useReminders();
	const endOfToday = getEndOfToday();
	const todaysReminders = computed(
		() =>
			reminders.value instanceof Array &&
			reminders.value.filter((r) => r.date < endOfToday),
	);
	return { reminders: todaysReminders, ...rest };
};

export const useTodaysRemindersDeduped = () => {
	const { reminders, ...rest } = useTodaysReminders();

	const dedupedReminders = computed(() => {
		if (!reminders.value) return [];

		// Only show the latest reminder for each lead.
		const seen = new Set();
		const res = [];
		reminders.value.forEach((r) => {
			if (seen.has(r.lead.id)) return;
			seen.add(r.lead.id);
			res.push(r);
		});
		return res;
	});

	return { reminders: dedupedReminders, ...rest };
};
